import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container p-4" }
const _hoisted_2 = ["aria-invalid", "aria-describedby"]
const _hoisted_3 = {
  key: 0,
  id: "emailNotificheError",
  class: "text-danger small mt-1",
  role: "alert"
}

import { computed, onMounted, ref, watch } from "vue";
import * as valUtil from "@/helper/validationUtils";
import { useUserStore } from "@/stores/user";


export default /*@__PURE__*/_defineComponent({
  __name: 'SetEmail',
  props: {
    emailIniziale: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const userStore = useUserStore();
const email = ref<string | null>(null);
const inError = ref<{ [key: string]: string }>({} as { [key: string]: string });
const inputEmail = ref<HTMLInputElement | null>(null);

const emit = __emit;

const describedBy = computed(() =>
  inError.value["emailNotifiche"] ? "emailNotificheHint emailNotificheError" : "emailNotificheHint");

// watch e non onMounted: il contenuto del modale vive dentro <keep-alive>,
// quindi il componente non viene rimontato alle riaperture.
watch(() => props.emailIniziale, (value) => {
  email.value = value ?? null;
  inError.value = {};
}, { immediate: true });

onMounted(() => {
  // Il modale è già nel DOM al mount: il focus va spostato quando diventa visibile.
  inputEmail.value?.closest(".modal")
    ?.addEventListener("shown.bs.modal", () => inputEmail.value?.focus());
});

function clearValidation(e: Event) {
  valUtil.clearValidation(inError, e as InputEvent & { target: { id: string } });
}

function save() {
  if (valUtil.validationEmail(email.value)) {
    userStore.updateUser(email.value ?? null, null, null).then(() => {
      emit("close");
    });
  } else {
    inError.value["emailNotifiche"] = "Inserire una mail valida per le notifiche";
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("p", { id: "emailNotificheHint" }, "L’indirizzo email inserito è utilizzato dal sistema per inviare le notifiche in caso di importanti aggiornamenti relativi alle istanze presentate", -1)),
    _cache[2] || (_cache[2] = _createElementVNode("label", {
      for: "emailNotifiche",
      class: "active field-required"
    }, "Email per notifica", -1)),
    _withDirectives(_createElementVNode("input", {
      ref_key: "inputEmail",
      ref: inputEmail,
      id: "emailNotifiche",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
      type: "email",
      class: "form-control",
      autocomplete: "email",
      required: "",
      "aria-invalid": !!inError.value['emailNotifiche'],
      "aria-describedby": describedBy.value,
      onInput: clearValidation
    }, null, 40, _hoisted_2), [
      [_vModelText, email.value]
    ]),
    (inError.value['emailNotifiche'])
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(inError.value["emailNotifiche"]), 1))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      onClick: save,
      class: "btn btn-success mt-3",
      "data-focus-mouse": "false"
    }, "Conferma")
  ]))
}
}

})